var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BilletInfo } from "@/components/common/BilletInfo";
import { Container } from "@/components/common/Container";
import { EvaluateServiceButton } from "@/components/common/EvaluateServiceButton";
import { MerchanApp } from "@/components/common/MerchanApp";
import { PageTitle } from "@/components/common/PageTitle";
import { RequestProof } from "@/components/common/RequestProof";
import { ServiceInfo, ServiceInfoItem } from "@/components/common/ServiceInfo";
import { useStepperControl } from "@/hooks/useStepperControl";
import GatewayService from "@/services/api/GatewayService";
import { CheckCircleIcon, TriangleAlert } from "lucide-react";
import { useState } from "react";
import { DialogBoletoDetails } from "./components/DialogBoletoDetails";
import { Breadcrumbs } from "@/components/common/Breadcrumbs";
var BREADCRUMB_ITEMS = [
    {
        name: "Página Inicial",
        path: "https://portal.pi.gov.br/detran/",
    },
    {
        name: "Solicitar Renovação",
        path: "/",
    },
    {
        name: "Pagamento",
        path: "/",
        current: true,
    },
];
export function Tax() {
    var service = new GatewayService();
    var _a = useState(false), showBoleto = _a[0], setShowBoleto = _a[1];
    var serviceReturn = useStepperControl().serviceReturn;
    return (_jsxs(Container, { children: [_jsx(Breadcrumbs, { pages: BREADCRUMB_ITEMS }), _jsx(PageTitle, { title: "Renova\u00E7\u00E3o de CNH" }), _jsxs("div", __assign({ className: "w-full max-w-[856px] flex flex-col gap-2" }, { children: [_jsx(ServiceInfo, __assign({ bgColorClass: "bg-green-100" }, { children: _jsx(ServiceInfoItem, { title: "Sua solicita\u00E7\u00E3o foi criada!", titleIcon: _jsx(CheckCircleIcon, { className: "text-black-900" }), content: [
                                "Pague a taxa pendente abaixo para validar sua solicitação.",
                            ], listType: "none" }) })), _jsx(BilletInfo, { data: serviceReturn, handleShowBoleto: setShowBoleto })] })), _jsxs("section", __assign({ className: "w-full max-w-[856px] bg-light-yellow-alert flex flex-col justify-between px-6 py-3 rounded-lg" }, { children: [_jsxs("div", __assign({ className: "flex items-center gap-2 py-2" }, { children: [_jsx(TriangleAlert, { className: "text-black-900" }), _jsx("span", __assign({ className: "font-medium text-center" }, { children: "Aten\u00E7\u00E3o!" }))] })), _jsx("p", __assign({ className: "font-light" }, { children: "Caso o pagamento n\u00E3o seja confirmado em at\u00E9 15 dias, o protocolo ser\u00E1 CANCELADO automaticamente." }))] })), _jsxs(ServiceInfo, { children: [_jsx(ServiceInfoItem, { title: "Para finalizar a renova\u00E7\u00E3o da sua CNH, dirija-se a uma unidade do DETRAN com os seguintes documentos:", 
                        // titleIcon={<CheckCircleIcon className="text-black-900" />}
                        content: [
                            "Carteira de Identidade Nacional (CIN) ou outro documento oficial com foto; ",
                            "Comprovante de residência atualizado;",
                        ], listType: "unordered" }), _jsx(ServiceInfoItem, { title: "", content: [
                            "A entrega dos documentos é essencial para concluir o processo e garantir a emissão da nova CNH.",
                        ], listType: "none" })] }), _jsx("section", __assign({ className: "hidden lg:block w-full max-w-[856px] rounded-lg p-6 border-l-2 border-r-2 border-t-2 border-b-2 bg-light-blue-100 space-y-6" }, { children: _jsx(RequestProof, { serviceReturn: serviceReturn }) })), _jsx("section", { children: _jsx(MerchanApp, {}) }), _jsx(EvaluateServiceButton, {}), _jsx(DialogBoletoDetails, { serviceReturn: serviceReturn, service: service, showBoleto: showBoleto, setShowBoleto: setShowBoleto })] }));
}
